import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ConnectivityIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.0033 2.67189C5.13664 2.67189 2.5233 3.73855 0.52997 5.49855C0.236637 5.75855 0.216637 6.20522 0.48997 6.47856L7.52997 13.5319C7.78997 13.7919 8.20997 13.7919 8.47664 13.5319L15.5166 6.47856C15.79 6.20522 15.77 5.75855 15.4766 5.49855C13.4155 3.67338 10.7564 2.66764 8.0033 2.67189ZM8.00391 8.00525C8.00391 8.00525 6.43724 7.95858 5.00391 9.00525L1.94997 6.05189C3.67664 4.72522 5.7833 4.00522 8.0033 4.00522C10.2233 4.00522 12.33 4.72522 14.0566 6.05189L11.0039 9.00525C9.523 7.92421 8.00391 8.00525 8.00391 8.00525Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

ConnectivityIcon.displayName = 'ConnectivityIcon';
